import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryTenantTagSetOverview } from "../../CommonComponents/CommonLibraryTenantTagSetViews";
export const LibraryTenantTagSetsNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.tagSets.create,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryTenantTagSetOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
